import config from 'constants/config'

export function isMetasearchDiscountEnabled(): boolean {
  return config.METASEARCH_DISCOUNT_ENABLED
}

export interface MetasearchDiscountRequestKeyContext {
  token: string
  propertyId: string
  checkIn: string
  checkOut: string
  occupancy: Array<string>
  price: number
  /**
   * Google's raw stored rate-rule ID, forwarded verbatim. A core resolve input: the same
   * token/property/dates/occupancy/price can resolve to a different country-specific discount,
   * so it must key the request. Absence stays absent — never coerced to a sentinel.
   */
  rateRuleId?: string
}

export function buildMetasearchDiscountRequestKey(context: MetasearchDiscountRequestKeyContext): string {
  return [
    context.token,
    context.propertyId,
    context.checkIn,
    context.checkOut,
    context.occupancy.join('/'),
    context.price,
    context.rateRuleId ?? '',
  ].join('|')
}

export function hasMetasearchDiscountContext(input: {
  token?: string
  propertyId?: string
  checkIn?: string
  checkOut?: string
  occupancy?: Array<string>
  price?: number
  rateRuleId?: string
}): input is {
  token: string
  propertyId: string
  checkIn: string
  checkOut: string
  occupancy: Array<string>
  price: number
  rateRuleId?: string
} {
  return !!(
    input.token &&
    input.propertyId &&
    input.checkIn &&
    input.checkOut &&
    input.occupancy?.length &&
    input.price &&
    input.price > 0
  )
}
